import React from 'react';
import Visa from '../../../assets/Service-icon/Visa Approval odds.svg';
import Transparency from '../../../assets/Service-icon/Transparency.svg';
import Guidance from '../../../assets/Service-icon/Expert guidence.svg';
import Information from '../../../assets/Service-icon/Information.svg';
import VisaApplication from '../../../assets/Service-icon/Accurate Visa Applications.svg';
import RegularUpdates from '../../../assets/Service-icon/Regular Status.svg';

const Benefits = () => {
  const options = [
    {
      id: 1,
      img: Visa,
      title: 'Increase Visa Approval Odds',
    },
    {
      id: 2,
      img: Transparency,
      title: 'Ensured Transparency and Confidentiality',
    },
    {
      id: 3,
      img: Guidance,
      title: 'Expert Guidance for the Visa Application Process',
    },
    {
      id: 4,
      img: Information,
      title: 'Up-to-date Information on Visa Requirements and Documentation',
    },
    {
      id: 5,
      img: VisaApplication,
      title: 'Submission of Complete and Accurate Visa Applications',
    },
    {
      id: 6,
      img: RegularUpdates,
      title: 'Regular Status Updates on Your Visa Application',
    },
  ];

  return (
    <div className='mb-10 px-4 py-10 text-center'>
      {/* Main Heading */}
      <h1 className='mb-12 text-3xl font-extrabold leading-snug text-gray-900 md:text-6xl'>
        Why Choose BlueLagoon Travels?
      </h1>

      {/* Grid */}
      <div className='mx-auto grid max-w-7xl gap-8 md:grid-cols-3'>
        {options.map((item) => (
          <div
            key={item.id}
            className='service_card flex flex-col items-center rounded-lg'
          >
            <img
              src={item.img}
              alt={item.title}
              className='mb-4 h-24 w-24 object-contain'
            />
            <h3 className='text-dark mb-2 text-xl font-semibold md:text-2xl'>{item.title}</h3>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Benefits;
